import { ThemeTypographyObject, VariantObjects } from '../types/theme';

type PressTypeTypography = 'PRESSbodyL'
|'PRESSbody'
| 'PRESSbodyS'
| 'PRESSbodyXS'
| 'PRESSeyebrowHeadline'
| 'PRESSeyebrowHeadlineS'
| 'PRESSlist'
| 'PRESSquoteXL'
| 'PRESSquoteL'
| 'PRESSquoteM'
| 'PRESSquoteS'
| 'PRESSquoteXS';

export type PressTypographyVariants = VariantObjects<PressTypeTypography, ThemeTypographyObject>;

const pressTypography: PressTypographyVariants = {
  PRESSquoteXL: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'text'
  },
  PRESSquoteL: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'text'
  },
  PRESSquoteM: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'text'
  },
  PRESSquoteS: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'text'
  },
  PRESSquoteXS: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'text'
  },
  PRESSbodyL: {
    fontWeight: 'regular',
    fontSize: 5,
    lineHeight: 'body',
    marginTop: 0,
    marginBottom: 5,
    color: 'text'
  },
  PRESSbody: {
    fontWeight: 'regular',
    fontSize: 4,
    lineHeight: 'body',
    marginTop: 0,
    marginBottom: 5,
    color: 'text'
  },
  PRESSbodyS: {
    fontWeight: 'regular',
    fontSize: 3,
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 4,
    color: 'text'
  },
  PRESSbodyXS: {
    fontWeight: 'regular',
    fontSize: 2,
    lineHeight: 'paragraph',
    marginTop: 0,
    marginBottom: 3,
    color: 'text'
  },
  PRESSlist: {
    fontWeight: 'regular',
    fontSize: 4,
    lineHeight: 'body',
    marginTop: 4,
    marginBottom: 4,
    color: 'text'
  },
  PRESSeyebrowHeadline: {
    textTransform: 'uppercase',
    fontSize: 3,
    marginBottom: 1,
    marginTop: 0,
    fontWeight: 'stronger'
  },
  PRESSeyebrowHeadlineS: {
    textTransform: 'uppercase',
    fontSize: 1,
    marginBottom: 1,
    marginTop: 0,
    fontWeight: 'stronger'
  }
};

export type AllPressTypographyTypeVariants = PressTypeTypography;

export const pressTypographyVariants = {
  ...pressTypography,
};

export const allPressTypographyKeyVariants = Object.keys(pressTypographyVariants);

export default pressTypographyVariants;
